<script>
    export default{
        data(){
            return{
                dados:{}
            }
        },
        ready: function()
        {
            var self = this;
            //json com os dados do header
            $.getJSON('./src/layout/rodape/data.json', function(dados)
            {                
                self.dados = dados[0];
                //console.log(self.dados)
            });
        }
    }
</script>

<template>
	<footer class="footer-1 bg-color-1">

                <!-- main footer begin -->
                <div class="main-footer">
                    <div class="">
						<div class="row">
							<div class="col-md-12 col-sm-12">
                                <div class="col-md-9 col-sm-4">
                                    <div class="compact-widget">                                                
                                        <div class="widget-inner">
                                            <p><iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fprefeituramunicipaldeigrapiuna%2F&tabs&width=220&height=154&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId" width="220" height="154" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true"></iframe></p>
                                            <div class="social-icons clearfix">
                                                <a :href="social.link" :class="social.classe" v-for="social in dados.social" target="_blank">
                                                    <i :class="social.icone"></i>
                                                </a>
                                            </div>
                                        </div>    
                                    </div>
                                </div>
								<div class="col-md-3 col-sm-4">
                                    <div class="compact-widget">
                                        <h3 class="widget-title">Contatos</h3>
                                        <div class="widget-inner">
                                            <p><i class="fa fa-home"></i> {{dados.endereco}}</p>
                                            <p><i class="fa fa-phone"></i> {{dados.telefone}}</p>
                                        </div>
                                    </div>
                                </div>
							</div>
						</div>
                        <div class="row">
                            <div class="copy-site">
                                <p>Copyright © 2015 - Todos os direitos reservados - Serviços ao Cidadão, Seu portal de serviços</p>
                                <p>Desenvolvido por <a title="M P Lopes" href="https://www.mplopes.com.br/" target="_blank">M P Lopes Sistemas de Informação</a></p>
                            </div>
                        </div>
                    </div>
                </div>            
                <!-- main footer close -->

            </footer>
</template>

<style scoped>
    footer{
        float: left;
        display: block;
        margin-top: 100px;
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// footer.vue?9ccc743c